import { Modal } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { generateQBOUrl } from 'utils/utils';
import { QuickbooksEmployee } from 'utils/svgs';
import styles from './index.module.scss';

interface AttemptDetail {
    attempt: number;
    docNumber: string;
    txnId: string;
}

interface DuplicateJournalErrorData {
    attempts: number;
    attemptDetails: AttemptDetail[];
}

interface Props {
    isOpen: boolean;
    errorData: DuplicateJournalErrorData | null;
    onClose: () => void;
}

export const DuplicateJournalErrorModal = (props: Props) => {
    const { isOpen, errorData, onClose } = props;

    if (!errorData || !errorData.attemptDetails || errorData.attemptDetails.length === 0) {
        return null;
    }

    // Get unique transaction IDs
    const uniqueAttempts = errorData.attemptDetails.reduce((acc: AttemptDetail[], current: AttemptDetail) => {
        const exists = acc.find((item: AttemptDetail) => item.txnId === current.txnId);
        if (!exists) {
            acc.push(current);
        }
        return acc;
    }, []);

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            closable={true}
            footer={null}
            centered={false}
            className={styles['duplicate-journal-error-modal']}
            width={700}
            style={{ top: '25%' }}
        >
            <p
                style={{
                    fontWeight: 600,
                    fontSize: '16px',
                    marginBottom: '15px',
                    borderBottom: '1px solid #ccc',
                    paddingBottom: '10px',
                }}
            >
                <WarningOutlined style={{ color: '#faad14', marginRight: '8px' }} />
                Duplicate Document Number Warning
            </p>
            <div style={{ marginBottom: '15px', fontSize: '12px', lineHeight: '1.6' }}>
                <b>The journal could not be posted to QuickBooks due to repeated duplicate Document Number conflicts.</b>
                <br /><br />
                We attempted to post this journal using multiple automatically generated
                Document Numbers, but QuickBooks returned a duplicate Document Number
                error each time.
                <br /><br />
                To proceed, please manually review and adjust the Document Number for any one of these journals, then try posting again.
            </div>
            <div style={{ marginBottom: '10px', fontSize: '12px', fontWeight: 600 }}>
                Conflicting Journals:
            </div>
            <ul className={styles['journals-list']}>
                {uniqueAttempts.map((attempt: AttemptDetail, index: number) => {
                    const qboUrl = generateQBOUrl('journalentry', attempt.txnId);
                    return (
                        <li key={index} className={styles['journal-item']}>
                            <a
                                href={qboUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles['journal-link']}
                            >
                                <span className={styles['journal-number']}>#{attempt.docNumber}</span>
                                <QuickbooksEmployee />
                                <span className={styles['txn-id']}>(Journal ID: <span className={styles['txn-id-value']}>{attempt.txnId}</span>)</span>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </Modal>
    );
};

